import { Injectable } from '@angular/core';
import { FilterObject } from '../helpers/filter-object';

@Injectable({
  providedIn: 'root'
})
export class FilterStoreService {
  public getFilters(clazz: string) {
    const filters: FilterObject[] = [];
    const filterString = localStorage.getItem(clazz);
    if (filterString) {
      JSON.parse(filterString).forEach(filter => {
        filters.push(
          new FilterObject(
            filter.key,
            filter.value,
            filter.active,
            filter.numeric,
            filter.strictEquality,
            filter.startsWith,
            filter.alwaysTriggerRequest,
            filter.operation,
            filter.displayValue
          )
        );
      });
    }
    return filters;
  }

  public setFilters(clazz: string, filters: FilterObject[]) {
    localStorage.setItem(clazz, JSON.stringify(filters));
  }

  public getTypeOptions(clazz: string) {
    const typeOptions = [];
    const typeOptionsString = localStorage.getItem(clazz + '-typeOptions');
    if (typeOptionsString) {
      JSON.parse(typeOptionsString).forEach(typeOption => {
        typeOptions.push(typeOption);
      });
    }
    return typeOptions;
  }

  public setTypeOptions(clazz: string, typeOptions: any[]) {
    localStorage.setItem(clazz + '-typeOptions', JSON.stringify(typeOptions));
  }
}
